module.exports = __webpack_public_path__ + "static/img/NSW-22.12db02f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-22.jpg
// module id = +TJB
// module chunks = 0